module.exports = __webpack_public_path__ + "img/card_ip_stipulation6.89d0cf1a.svg";